import { readStoredJSON } from './state/appState';

export interface SiteModeConfig {
  maintenanceEnabled: boolean;
  eyebrow: string;
  title: string;
  description: string;
  note: string;
  updatedAt: string | null;
}

export const defaultSiteMode: SiteModeConfig = {
  maintenanceEnabled: false,
  eyebrow: 'Scheduled Maintenance',
  title: 'We are making a few improvements',
  description:
    'Zobu Consulting is currently under maintenance while we publish a refreshed version of the site. Please check back shortly.',
  note: 'Admin and staff access remain available.',
  updatedAt: null,
};

export function normalizeSiteModeConfig(value: unknown): SiteModeConfig {
  if (!value || typeof value !== 'object') {
    return defaultSiteMode;
  }

  const candidate = value as Partial<SiteModeConfig>;

  return {
    maintenanceEnabled: Boolean(candidate.maintenanceEnabled),
    eyebrow:
      typeof candidate.eyebrow === 'string' && candidate.eyebrow.trim()
        ? candidate.eyebrow.trim()
        : defaultSiteMode.eyebrow,
    title:
      typeof candidate.title === 'string' && candidate.title.trim()
        ? candidate.title.trim()
        : defaultSiteMode.title,
    description:
      typeof candidate.description === 'string' && candidate.description.trim()
        ? candidate.description.trim()
        : defaultSiteMode.description,
    note:
      typeof candidate.note === 'string' && candidate.note.trim()
        ? candidate.note.trim()
        : defaultSiteMode.note,
    updatedAt:
      typeof candidate.updatedAt === 'string' && candidate.updatedAt.trim()
        ? candidate.updatedAt
        : null,
  };
}

export function readSiteModeConfig(storageKey: string) {
  return normalizeSiteModeConfig(readStoredJSON(storageKey, defaultSiteMode));
}
